import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { resetSyncListState, syncList } from '../../actions/custom-showcase.actions';
import { CustomShowcaseForm } from '../../models/custom-showcase';
import { Subscription } from 'rxjs';
import { CustomShowcaseState, getSyncListState } from '../../reducers/custom-showcase.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-custom-showcase-list-sync-dialog',
  templateUrl: './custom-showcase-list-sync-dialog.component.html',
  styleUrls: ['./custom-showcase-list-sync-dialog.component.scss']
})
export class CustomShowcaseListSyncDialogComponent implements OnInit, OnDestroy {
  @Input() public showcase: CustomShowcaseForm;
  public errorMessage: string;
  public isSyncing: boolean;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly store: Store<CustomShowcaseState>,
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(resetSyncListState());
    this.subscriptions.add(
      this.store.select(getSyncListState).subscribe((syncListState) => {
        this.isSyncing = syncListState?.loading || false;
        this.errorMessage = syncListState?.errorMessage || null;

        if (syncListState?.synced) {
          this.activeModal.close();
        }
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onClose() {
    if (!this.isSyncing) {
      this.activeModal.dismiss();
    }
  }

  public onConfirm() {
    this.store.dispatch(syncList({
      showcaseId: this.showcase.id,
      listId: this.showcase.createdFrom.id,
    }));
  }

}
